export var isUserNotPrivilegedToTakeLoan = function (merchantResponseData) {
    return !merchantResponseData.data.merchantData.user.permission.newLoan;
};
